import CustomInputSelectionCheckboxV8 from "components/Inputs/CustomInputSelectionCheckboxV8"
import { FunctionComponent, useMemo } from "react"
import { Field } from "react-final-form"
import withWindowDimensions from "uiKit/utils/withWindowDimensions"
import CustomInputSelectionCheckboxV4 from "./CustomInputSelectionCheckboxV4"

interface Props {
  question: string
  subText?: string
  input: any
  label: string
  options: any
  meta: any
  className?: string
  isMultiSelect?: boolean
  numGridColumns?: number
  onClick?: Function
  setValue?: Function
  isMobileSized?: boolean
  checkBoxVersion?: number
  ieltsQe?: boolean
}
const CustomInputSelectV5: FunctionComponent<Props> = ({
  input,
  options,
  meta,
  isMultiSelect,
  subText,
  numGridColumns,
  onClick,
  setValue,
  isMobileSized,
  checkBoxVersion = null,
  ieltsQe,
}) => {
  const gridColCssStr = useMemo(() => "grid-cols-2", [numGridColumns])
  return (
    <>
      <div className="text-lightgray-800 text-font14 md:text-base">
        {subText}
      </div>
      <div className={`${gridColCssStr}  `}>
        {options.map((option: any, i: number) => {
          const { label, value, icon, remainder, color } = option
          return (
            <label key={i}>
              <Field
                name={input.name}
                component={
                  checkBoxVersion === 8
                    ? CustomInputSelectionCheckboxV8
                    : CustomInputSelectionCheckboxV4
                }
                type={isMultiSelect ? "checkbox" : "radio"}
                value={value}
                label={label}
                icon={icon}
                color={color}
                isMobileSized={isMobileSized}
                remainder={remainder}
                optionSize={options.length}
                onClick={onClick}
                setValue={setValue}
                ieltsQe={ieltsQe}
              />
            </label>
          )
        })}
      </div>
      {meta.touched && meta.error && (
        <p className="mt-1 text-xs text-red-600 md:pl-2 pl-4">{meta.error}</p>
      )}
    </>
  )
}
export default withWindowDimensions(CustomInputSelectV5)
